var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('div',{staticClass:"my-3"},[_c('b-skeleton',{attrs:{"width":"100%","height":"50px"}})],1)]),_c('b-row',[_c('div',{staticClass:"my-3"},[_c('b-skeleton',{attrs:{"width":"100%","height":"50px"}})],1)]),_c('b-row',[_c('div',{staticClass:"my-3"},[_c('b-skeleton',{attrs:{"width":"100%","height":"50px"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }